import React from 'react';

const ClubLoadingFailure = () => <span>Problem loading club</span>;

export default ClubLoadingFailure;
